import { render, staticRenderFns } from "./addsentityWord.vue?vue&type=template&id=176a03aa&"
import script from "./addsentityWord.vue?vue&type=script&lang=js&"
export * from "./addsentityWord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('176a03aa')) {
      api.createRecord('176a03aa', component.options)
    } else {
      api.reload('176a03aa', component.options)
    }
    module.hot.accept("./addsentityWord.vue?vue&type=template&id=176a03aa&", function () {
      api.rerender('176a03aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/components/addsentityWord.vue"
export default component.exports